export const currencyChoiceType = {
    notChosen: 'notChosen',
    projectCurrency: 'projectCurrency',
    otherCurrency: 'otherCurrency',
};
